// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "p#online-details ul.list{margin-bottom:0}", "",{"version":3,"sources":["webpack://./src/main/webapp/WEB-INF/views/fmfmo/common/RecoveryDetailsPart.vue"],"names":[],"mappings":"AAGI,yBACI,eAAA","sourcesContent":["\n\np#online-details {\n    ul.list {\n        margin-bottom: 0;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
